import React, {useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';

import ConfirmDialog from './ConfirmDialog.js';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
//import MessageIcon from '@material-ui/icons/Message';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
//import DescriptionIcon from '@material-ui/icons/Description';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const useStyles = makeStyles((theme) => ({
    textForm: {
      textAlign: "left",
      //flexGrow: 1,
      //marginLeft:theme.spacing(1),
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    text: {
      textAlign: "center",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    textExplanation: {
      textAlign: "justify",
      //padding: theme.spacing(2),
      //margin: theme.spacing(2),
    },
    select: {
      minWidth: 250,
    },
    table: {
        minWidth: 650,
    }
}));

export default function SleepLogTable (props) {
    const classes = useStyles();
    const {value} = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDetails, setOpenDetails] = useState(false);
    const [details, setDetails] = useState("");

    // Open Details Dialog (for selected individual survey)
    const handleClickDetailsOpen = (date, heading, score, questions) => { 

        const detailsText = <>
        <Typography variant="subtitle1" component="span">{date} <strong>{heading}</strong></Typography>
        <br/><br/>
        <Typography variant="subtitle2" component="span">
        {questions.map(question=><React.Fragment key={question.text}><em><strong>{question.text}</strong></em> :<br/>{question.choice}, {question.answers[question.choice]}<br/><br/></React.Fragment>)}
        <br/>
        </Typography>
        <Typography variant="subtitle1" component="span">Total: {score} </Typography>
        </>;

        setDetails(detailsText);
        setOpenDetails(true);
    };
    
    // Close Details Dialog
    const handleDetailsClose = (value) => {
        setOpenDetails(false);
    };


    function handlePageChange(event, newPage) {
        setPage(newPage);
    }

    function handleRowsPerPageChange(event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    if (value){
    return <>
    <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="sleep-log-data-table">
            <TableHead> 
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>{value.docs[value.docs.length-1].get("surveyPartAHeading")}{value.docs[value.docs.length-1].get("surveyPartASuffix")}</TableCell>
                    <TableCell>{value.docs[value.docs.length-1].get("surveyPartBHeading")}{value.docs[value.docs.length-1].get("surveyPartBSuffix")}</TableCell>
                    <TableCell>Comments</TableCell>
                    <TableCell padding="checkbox"></TableCell>       
                </TableRow>
            </TableHead>
            <TableBody>
                {value.docs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(doc=>
                    <TableRow key={doc.id}>
                        <TableCell component="th" scope="row">{doc.get("date").toDate().toLocaleDateString("en-US")}</TableCell>
                        <TableCell>{doc.get("surveyPartAScore")}, {doc.get("surveyPartAInterpretation")}<br/><IconButton onClick={()=>handleClickDetailsOpen(doc.get("date").toDate().toLocaleDateString("en-US"), doc.get("surveyPartAHeading"), doc.get("surveyPartAScore"), doc.get("surveyPartACompleteData"))}><MoreHorizIcon/></IconButton></TableCell>
                        <TableCell>{doc.get("surveyPartBScore")}, , {doc.get("surveyPartBInterpretation")}<br/><IconButton onClick={()=>handleClickDetailsOpen(doc.get("date").toDate().toLocaleDateString("en-US"), doc.get("surveyPartBHeading"), doc.get("surveyPartBScore"), doc.get("surveyPartBCompleteData"))}><MoreHorizIcon/></IconButton></TableCell>
                        <TableCell>{doc.get("comments")}{doc.get("comments") === "" && "None"}</TableCell>
                        <TableCell><IconButton onClick={()=>props.onConfirmDeleteOpen(doc.id)}><DeleteForeverIcon/></IconButton></TableCell>
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer> 
    <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={value.docs.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
        />
    <ConfirmDialog title={"Details"} description={<React.Fragment>{details}</React.Fragment>} agree="OK" disagree={null} open={openDetails} onCloseClick= {null} onAgreeClick={handleDetailsClose}/>
    </>
    }
    return null;
}

